module.exports = __webpack_public_path__ + "static/img/forums.c37ec25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpg/forums.jpg
// module id = 192
// module chunks = 0